<template>
    <div
        v-if="tips && tips.length > 0"
        class="error-tips-container"
    >
        <div
            v-for="(tip, index) in tips"
            :key="index"
            class="error-tip-item"
        >
            <!-- <i class="error-icon">!</i> -->
            <span class="error-text">识别提示：{{ tip }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErrorTips',
    props: {
        tips: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang="scss" scoped>
.error-tips-container {
    margin-top: 8px;
}

.error-tip-item {
    display: flex;
    align-items: center;
    background-color: #fef0f0;
    border: 1px solid #fbc4c4;
    border-radius: 4px;
    padding: 8px 12px;
    margin-bottom: 8px;
    font-size: 12px;
    line-height: 1.4;
    color: #f56c6c;
}

.error-tip-item:last-child {
    margin-bottom: 0;
}

.error-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background-color: #f56c6c;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    margin-right: 8px;
    flex-shrink: 0;
}

.error-text {
    flex: 1;
    word-break: break-all;
}
</style>
